export default {
  login: {
    title: 'Masuk ke halaman saya',
    double_check_text: 'Gagal masuk. Masukkan data yang benar.',
    id_email: 'ID/alamat email',
    password: 'Kata sandi',
    password_display: 'Tampilkan kata sandi',
    password_no_display: 'Sembunyikan kata sandi',
    login: 'Login',
    keep_login_text: 'Simpan status login',
    forgot_password_text: 'Lupa kata sandi',
    contact_us: 'Daftar di sini',
    asuene_service_outline: 'Layanan cloud visualisasi CO2 "ASUENE"',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'Platform Perekrutan Berfokus Bakat GX/ESG "ASUENE CAREER"',
    corporate_page: 'Situs web perusahaan',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
